module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot7-a0d22e7e26ac2f58246f6f44b4b5fc41.png";